import type { IFoodtable } from 'models/IFeed'

/**
 * Mock для превью FoodtableChart (внутри FeedAvailabilityWidget).
 */
export const FOODTABLE_MOCK: IFoodtable[] = [
	{
		barn_title: 'Корпус 1',
		food_info: [
			{
				group_title: 'Группа А',
				last_distribution: 1709827200,
				reachable_percent: 85,
				total_percent: 100,
				unreachable_percent: 10,
				camera_issue: false,
			},
			{
				group_title: 'Группа Б',
				last_distribution: 1709827200,
				reachable_percent: 70,
				total_percent: 100,
				unreachable_percent: 25,
				camera_issue: false,
			},
		],
	},
]
